var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component"},'component',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }